import { render, staticRenderFns } from "./TheCookieBanner.vue?vue&type=template&id=506742d3"
import script from "./TheCookieBanner.vue?vue&type=script&lang=ts"
export * from "./TheCookieBanner.vue?vue&type=script&lang=ts"
import style0 from "./TheCookieBanner.vue?vue&type=style&index=0&id=506742d3&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports